module.exports = __webpack_public_path__ + "img/27.201f69b4.png";